import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RadioButton, RadioButtonGroup } from 'material-ui';
import Button from '../../../../core/modules/common/components/Button';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import { getCurrentReport, getUserType } from '../../../user/redux/selectors/UserReportSelectors';
import { getSelectionCriteria } from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import { reportLoadData } from '../redux/actions/ReportsActions';
import { getReportCustomFilter } from '../redux/selectors/ReportsSelectors';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
import themeStyles from '../../../../materialUiTheme';

class ReportCustomFiltersEdiExchange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allOrigin: this.props.customFilter.allOrigin,
      allDestination: this.props.customFilter.allDestination,
      showSending: this.props.customFilter.showSending,
      showReceiving: this.props.customFilter.showReceiving,
      showMailBoxes: this.props.customFilter.showMailBoxes,
    };
  }

  onShowAllSelect = (selected) => {
    this.loadReport({
      ...this.state,
      allOrigin: selected.indexOf('allOrigin') > -1,
      allDestination: selected.indexOf('allDestination') > -1,
    });
  };

  onRadioGroupChange = (event) => {
    this.loadReport({
      ...this.state,
      showSending: event.target.value === 'sending',
      showReceiving: event.target.value === 'receiving',
    });
  }

  onShowMailboxesClick = () => {
    this.loadReport({
      ...this.state,
      showMailBoxes: !this.state.showMailBoxes,
    });
  }

  getSelecedShowAll = () => {
    const selected = [];
    if (this.state.allOrigin) selected.push('allOrigin');
    if (this.state.allDestination) selected.push('allDestination');
    return selected;
  }

  loadReport = (state) => {
    const { reportCode } = this.props.currentReport;
    const report = ReportDefinitions[reportCode];
    const selectionCriteria =
      new SelectionCriteriaDto(this.props.selectionCriteria, report.selectionCriteria.items);
    this.props.reportLoadData(report, reportCode, {
      ...selectionCriteria,
      ...state,
    });
    this.setState(state);
  };

  render() {
    const {
      userType,
      currentUserType = '',
    } = this.props;

    return (
      <div className="custom-filter-list">
        {(!userType || userType === currentUserType) &&
          <div className="checkbox-group-tree">
            <CheckboxTreeSelector
              nodes={[
                {
                  value: 'allOrigin',
                  label: 'Show all messages regardless of origin',
                },
                {
                  value: 'allDestination',
                  label: 'Show all messages regardless of destination',
                },
              ]}
              selected={this.getSelecedShowAll()}
              onSelect={this.onShowAllSelect}
              expandDisabled
              allSelectorDisabled
            />
          </div>
        }
        <div className="radio-group-tree">
          <RadioButtonGroup
            name="receiving-sending"
            valueSelected={this.state.showSending ? 'sending' : 'receiving'}
            onChange={this.onRadioGroupChange}
          >
            <RadioButton
              value="receiving"
              label="Show Receiving"
              key="receiving"
            />
            <RadioButton
              value="sending"
              label="Show Sending"
              key="sending"
            />
          </RadioButtonGroup>
        </div>
        <Button
          onClick={this.onShowMailboxesClick}
          text="app.report.show.mailboxes"
          style={this.state.showMailBoxes ?
            themeStyles.blueButton : themeStyles.blueButton.disabled}
        />
      </div>
    );
  }
}

ReportCustomFiltersEdiExchange.propTypes = {
  userType: PropTypes.string,
  currentUserType: PropTypes.string,
  currentReport: PropTypes.objectOf(PropTypes.shape),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  customFilter: PropTypes.objectOf(PropTypes.shape),
  reportLoadData: PropTypes.func,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    reportLoadData,
  }, dispatch);

const mapStateToProps = state => ({
  currentReport: getCurrentReport(state),
  currentUserType: getUserType(state),
  selectionCriteria: getSelectionCriteria(state),
  customFilter: getReportCustomFilter(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportCustomFiltersEdiExchange);
